module.exports = __webpack_public_path__ + "static/img/women-and-drones-logo.35751c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women-and-drones-logo.png
// module id = myaV
// module chunks = 0